if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-product-list",
      };

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          this.products = recommendations.querySelectorAll(".m-product-card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            MinimogTheme.CompareProduct?.setCompareButtonsState();
            MinimogTheme.Wishlist?.setWishlistButtonsState();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const slideContainer = this.querySelector(".m-product-list");
      const slideControls = this.querySelector(".m-slider-controls");
      const innerWrapper = slideContainer && slideContainer.querySelector("[data-products-container]");

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (innerWrapper) {
          innerWrapper.classList.remove("swiper-wrapper");
          innerWrapper.style.transform = '';
          innerWrapper.style.transition = '';
        }
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        if (innerWrapper) innerWrapper.classList.add("swiper-wrapper");
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (this.products <= parseInt(this.items)) {
        slideControls && slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const slideContainer = this.querySelector(".m-product-list");
      if (!slideContainer) return;

      slideContainer.classList.add("swiper-container");

      // Crea i bottoni nav se non esistono già nel DOM
      let controlsContainer = this.querySelector(".m-slider-controls");
      if (!controlsContainer) {
        controlsContainer = document.createElement("div");
        controlsContainer.className = "m-slider-controls m-slider-controls--absolute m-slider-controls--bottom-center";
        controlsContainer.innerHTML = `
          <button class="m-slider-controls__button m-slider-controls__button-prev" aria-label="Previous">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>
          <button class="m-slider-controls__button m-slider-controls__button-next" aria-label="Next">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        `;
        slideContainer.parentNode.appendChild(controlsContainer);
      }

      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");

      // Testo "Swipe to see more" da mostrare al posto dei pallini su mobile
      // (il CSS decide quale dei due mostrare in base alla larghezza schermo).
      // Inserito una sola volta: initSlider() puo' essere richiamata piu' volte
      // (cambio breakpoint mobile/desktop) senza ri-creare il testo ogni volta.
      if (controlsContainer && !controlsContainer.querySelector(".m-swipe-hint")) {
        const hint = document.createElement("span");
        hint.className = "m-swipe-hint";
        hint.textContent = "Swipe to see more";
        const paginationEl0 = controlsContainer.querySelector(".swiper-pagination");
        if (paginationEl0) {
          paginationEl0.insertAdjacentElement("afterend", hint);
        } else {
          controlsContainer.appendChild(hint);
        }
      }
      const swipeWrapper = slideContainer.querySelector(".swiper-wrapper");
      const slideItemsLength = swipeWrapper ? swipeWrapper.childElementCount : 0;

      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      // FIX (solo mobile): querySelector(".swiper-pagination") scoped su "this"
      // prendeva il PRIMO .swiper-pagination nel DOM, cioe' quello "standalone"
      // fuori dai controls, non quello dentro .m-slider-controls tra le due
      // freccie. Su mobile vogliamo i pallini dentro i controls; su desktop
      // lasciamo il comportamento originale invariato.
      const isMobileView = MinimogTheme.config.mqlMobile;
      const paginationEl = (isMobileView && controlsContainer && controlsContainer.querySelector(".swiper-pagination"))
        || this.querySelector(".swiper-pagination");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        loop: false,
        pagination: this.showPagination
          ? { el: paginationEl, clickable: true }
          : false,
        breakpoints: {
          768: { slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items) },
          1024: { slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items) },
          1280: { slidesPerView: parseInt(this.items) },
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
              }
              if (prevButton) prevButton.style.display = "flex";
              if (nextButton) nextButton.style.display = "flex";
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider) {
        if (prevButton) prevButton.addEventListener("click", () => this.slider.slidePrev());
        if (nextButton) nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer.swiper;
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
